import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import bgImg from "../../assets/img/bg/home12/services-bg.jpg";
import shapeImg from "../../assets/img/bg/services-bg-shape.png";

import serviceImg1 from "../../assets/img/maintainace.png";
import serviceImg2 from "../../assets/img/cyber.png";
import serviceImg3 from "../../assets/img/robotics.png";
import serviceImg4 from "../../assets/img/software development.png";
import serviceImg5 from "../../assets/img/technical.png";
import serviceImg6 from "../../assets/img/devops.png";
import serviceImg7 from "../../assets/img/QA.png";
import serviceImg8 from "../../assets/img/digital.png";
import serviceImg9 from "../../assets/img/IT.png";
import serviceImg10 from "../../assets/img/dev.png";
import serviceImg11 from "../../assets/img/data.png";
import serviceImg12 from "../../assets/img/work.png";

const services = [
  { img: serviceImg1, title: "Mobile App Development", link: "/consultation/mobile-app-development", desc: "Native iOS & Android apps built for performance and user experience" },
  { img: serviceImg4, title: "Web Application Development", link: "/consultation/web-application-development", desc: "Scalable web platforms engineered for growth and reliability" },
  { img: serviceImg3, title: "AI & Machine Learning", link: "/consultation/ai-machine-learning", desc: "Intelligent automation and predictive analytics solutions" },
  { img: serviceImg2, title: "Cyber Security & VAPT", link: "/consultation/cyber-security-vapt", desc: "Comprehensive security testing and vulnerability assessment" },
  { img: serviceImg6, title: "DevSecOps & Platform Engineering", link: "/consultation/devsecops-platform-engineering", desc: "Secure CI/CD pipelines and infrastructure automation" },
  { img: serviceImg5, title: "CTO-as-a-Service", link: "/consultation/cto-as-a-service", desc: "On-demand technology leadership and strategic guidance" },
  { img: serviceImg10, title: "System Architecture & Solution Design", link: "/consultation/system-architecture-solution-design", desc: "Robust architectures for scalable enterprise systems" },
  { img: serviceImg12, title: "Product Discovery & MVP Development", link: "/consultation/product-discovery-mvp-development", desc: "Rapid prototyping and market validation strategies" },
  { img: serviceImg8, title: "Digital Transformation", link: "/consultation/digital-transformation", desc: "Modernize processes and technology for competitive advantage" },
  { img: serviceImg11, title: "Performance Optimization & Scalability", link: "/consultation/performance-optimization-scalability", desc: "Optimize applications to handle millions of users" },
  { img: serviceImg7, title: "Quality Assurance & Testing", link: "/consultation/quality-assurance-testing", desc: "Comprehensive testing for production-ready software" },
  { img: serviceImg9, title: "Ongoing Support & Engineering Partnership", link: "/consultation/ongoing-support-engineering-partnership", desc: "24/7 monitoring, maintenance, and continuous improvement" },
];

const ServiceCard = ({ service, index, isVisible }) => {
  const [isHovered, setIsHovered] = useState(false);
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const card = cardRef.current;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Calculate rotation based on mouse position
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * -5; // Max 5 degrees
    const rotateY = ((x - centerX) / centerX) * 5; // Max 5 degrees

    card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (cardRef.current) {
      cardRef.current.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale(1)';
    }
  };

  return (
    <div
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.05}s, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.05}s`
      }}
    >
      <Link
        to={service.link}
        style={{ textDecoration: 'none', display: 'block', height: '100%' }}
      >
        <div
          ref={cardRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '40px 32px',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
            cursor: 'pointer',
            border: '1px solid #e5e7eb',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
            willChange: 'transform'
          }}
        >
          {/* Animated Background Gradient Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.03) 0%, rgba(255, 255, 255, 0) 100%)',
            opacity: 1,
            transition: 'opacity 0.4s ease',
            zIndex: 0
          }}></div>

          {/* Glowing Top Border */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: 'linear-gradient(90deg, #ffc107, #ffd54f)',
            transform: 'scaleX(1)',
            transformOrigin: 'left',
            transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            zIndex: 1
          }}></div>

          {/* Content Wrapper */}
          <div style={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>

            {/* Icon Box */}
            <div style={{
              width: '72px',
              height: '72px',
              marginBottom: '28px',
              background: '#fff8e1',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
              transform: 'rotate(-5deg) scale(1.1)'
            }}>
              <img
                src={service.img}
                alt={service.title}
                style={{
                  width: '42px',
                  height: '42px',
                  objectFit: 'contain',
                  transition: 'all 0.4s ease',
                  filter: 'none',
                  opacity: 1
                }}
              />
            </div>

            {/* Title */}
            <h3 style={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#111827',
              marginBottom: '16px',
              lineHeight: 1.3,
              transition: 'color 0.3s ease'
            }}>
              {service.title}
            </h3>

            {/* Description */}
            <p style={{
              fontSize: '15px',
              color: '#4b5563',
              lineHeight: 1.6,
              margin: '0 0 24px 0',
              flex: 1,
              transition: 'color 0.3s ease'
            }}>
              {service.desc}
            </p>

            {/* Action Area */}
            <div style={{
              marginTop: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderTop: '1px solid rgba(255, 193, 7, 0.2)',
              paddingTop: '20px',
              transition: 'border-color 0.3s ease'
            }}>
              <span style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#b45309',
                transition: 'color 0.3s ease'
              }}>
                Learn more
              </span>

              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: '#ffc107',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                transform: 'translateX(0)'
              }}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  style={{
                    color: '#111827',
                    transition: 'color 0.3s ease'
                  }}
                >
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

const Service = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <React.Fragment>
      <section
        id="rs-services"
        ref={sectionRef}
        style={{
          padding: '120px 0',
          backgroundColor: '#ffc107',
          position: 'relative'
        }}
      >
        {/* Background Shape Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${shapeImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.1,
          pointerEvents: 'none',
          zIndex: 0
        }}></div>

        <div className="container" style={{ maxWidth: '1600px', margin: '0 auto', padding: '0 30px', position: 'relative', zIndex: 1 }}>

          {/* Header */}
          <div style={{
            maxWidth: '760px',
            margin: '0 auto 90px',
            textAlign: 'center',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(-30px)',
            transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)'
          }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              background: '#fff',
              borderRadius: '100px',
              marginBottom: '24px'
            }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#111827' }}></span>
              <span style={{
                fontSize: '13px',
                fontWeight: 600,
                color: '#111827',
                letterSpacing: '0.05em',
                textTransform: 'uppercase'
              }}>
                Our Services
              </span>
            </div>

            <h2 style={{
              fontSize: '48px',
              fontWeight: 800,
              color: '#111827',
              marginBottom: '24px',
              lineHeight: 1.1,
              letterSpacing: '-0.03em'
            }}>
              Transforming Ideas into <br />
              <span style={{ color: '#fff', position: 'relative', display: 'inline-block' }}>
                Digital Reality
                <svg width="100%" height="8" viewBox="0 0 200 8" fill="none" style={{ position: 'absolute', bottom: -4, left: 0, opacity: 0.6 }}>
                  <path d="M2 5.5C36.5 2.5 102.5 -1.5 198 5.5" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                </svg>
              </span>
            </h2>

            {/* <p style={{
              fontSize: '19px',
              color: '#4b5563',
              lineHeight: 1.7,
              margin: '0 auto',
              maxWidth: '600px'
            }}>
              We blend engineering excellence with creative innovation to build software that defines the future of your business.
            </p> */}
          </div>

          {/* Services Grid - 4 columns */}
          <div className="services-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '32px',
            marginBottom: '100px'
          }}>
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                service={service}
                index={index}
                isVisible={isVisible}
              />
            ))}
          </div>

          {/* CTA */}
          <div style={{
            textAlign: 'center',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.6s'
          }}>
            <Link
              to="/book-meeting"
              className="cta-button"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                padding: '20px 48px',
                background: '#111827',
                color: '#fff',
                borderRadius: '100px',
                fontSize: '18px',
                fontWeight: 700,
                textDecoration: 'none',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(17, 24, 39, 0.2), 0 2px 4px -1px rgba(17, 24, 39, 0.1)'
              }}
            >
              <span>Connect With Us</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        .services-grid {
          grid-template-columns: repeat(4, 1fr);
        }

        .cta-button:hover {
          background: #000 !important;
          transform: translateY(-3px) !important;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.1) !important;
        }

        .cta-button:hover svg {
          transform: translateX(4px);
          transition: transform 0.3s ease;
        }

        @media (max-width: 1400px) {
          .services-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }

        @media (max-width: 991px) {
          .services-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          h2 {
            font-size: 36px !important;
          }
        }

        @media (max-width: 576px) {
          .services-grid {
            grid-template-columns: 1fr !important;
          }
          h2 {
            font-size: 32px !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default Service;
